import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportTemplate: {
    templateName: '',
    selectedFields: [],
    isDefault: false,
  },
};

export const reportTemplateSlice = createSlice({
  name: 'reportTemplate',
  initialState,
  reducers: {
    updateSelectedFields: (state, action) => {
      state.reportTemplate.selectedFields = action.payload;
    },
    updateTemplateName: (state, action) => {
      state.reportTemplate.templateName = action.payload;
    },
    updateDefault: (state, action) => {
      state.reportTemplate.isDefault = action.payload;
    },
    updateTemplate: (state, action) => {
      state.reportTemplate = action.payload;
    },
    clearTemplate: (state) => {
      state.reportTemplate = initialState.reportTemplate;
    },
  },
});

export const reportTemplateSelector = (state) =>
  state.reportTemplate.reportTemplate;
export const {
  updateSelectedFields,
  updateTemplateName,
  updateDefault,
  updateTemplate,
  clearTemplate,
} = reportTemplateSlice.actions;

export const reportTemplateReducer = reportTemplateSlice.reducer;
export const reportTemplateReducerName = reportTemplateSlice.name;

export default reportTemplateSlice.reducer;
